import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable, catchError, tap, throwError } from 'rxjs';

import { disableSsrCaching } from '../helpers';
import { SERVER_RESPONSE, ServerResponse } from '../server/server.tokens';

/**
 * Handle Http response errors on server-side, main reason is for preventing
 * failing Http responses and resulting rendered html from being cached.
 * Errors will be regularly identified based on response code, however GraphQL
 * responses will have errors inside response body, while status code still is 200.
 * In case of request failure, the interceptor disables routeData.cacheConfig property in Express Response,
 * so Express server logic is able to subsequently handle the error (server only)
 */
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(@Optional() @Inject(SERVER_RESPONSE) private readonly response: ServerResponse) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const next$ = next.handle(req);
    return this.response
      ? next$.pipe(
          tap(event => {
            const error = event instanceof HttpResponse && event.body?.errors;
            if (Array.isArray(error) && error.length) {
              throw new HttpErrorResponse({ ...event, error });
            }
          }),
          catchError(event => {
            disableSsrCaching(this.response);
            return throwError(() => event);
          })
        )
      : next$;
  }
}
